// M201/M202: helpers do skalowania URL-i obrazów per użycie.
//
// Tradeinn ma dwa endpointy:
//   /f/<a>/<b>/name.webp — full 1000x1000 (~80-120 KB per image)
//   /h/<a>/<b>/name.webp — thumbnail 275x275 (~10-15 KB per image)
//
// W M124-M189 seed mieszał oba — większość użyła /h/ (lista produktów wystarczy 275),
// ale spearfishing-gear (M189) użyło /f/ dla maksymalnej jakości na product detail.
// Wynik: 64x64 thumb w galerii produktów wciąga 100 KB zamiast 15 KB.
//
// `cardImageUrl` używamy dla list/grid product cards (rendered ~400-600px). Większość URLi w DB
// to już /h/ — funkcja jest no-op dla nich, ale dla /f/ przerzuca na /h/.
//
// `thumbUrl` (w ProductDetails.tsx) używamy dla 64x64 sidebar thumbnails — agresywne /f/→/h/.

const TRADEINN_HOST = 'tradeinn.com'

function rewriteTradeinn(url: string, from: '/f/' | '/h/', to: '/f/' | '/h/'): string {
  try {
    const u = new URL(url)
    if (u.hostname.endsWith(TRADEINN_HOST) && u.pathname.startsWith(from)) {
      u.pathname = to + u.pathname.slice(from.length)
      return u.toString()
    }
    return url
  } catch {
    return url
  }
}

/**
 * Use dla 64x64 sidebar thumbnails (product detail gallery sidebar).
 * Zamienia /f/ → /h/ na tradeinn (275x275 jest dobry dla 64px display).
 */
export function thumbUrl(url: string): string {
  return rewriteTradeinn(url, '/f/', '/h/')
}

/**
 * Use dla list/grid product cards (~400-600px display). Tak samo /f/→/h/ — 275 px source
 * jest still slightly powyżej rzeczywistego rendered size na większości viewportów.
 * (Jeśli kiedyś dodamy /m/ medium tier — zmienimy tu.)
 */
export function cardImageUrl(url: string): string {
  return rewriteTradeinn(url, '/f/', '/h/')
}

/**
 * Use dla zdjęć artykułów poradników. Pole `photo`/`midPhoto` może być:
 *   - pełnym URL-em (np. zdjęcie produktu z tradeinn `/f/` — temat „o sprzęcie") → zwracamy as-is,
 *   - ID Unsplash typu `photo-XXXX-YYYY` (temat „o scenie/technice") → budujemy URL Unsplash z `query`.
 */
export function articleImg(photo: string, query: string): string {
  if (photo.startsWith('http')) return photo
  return `https://images.unsplash.com/${photo}?${query}`
}
